import productModel from './productModel';


const impressionModel = function googleAnalyticsProductImpressionModel(products, list) {
  return {
    event: 'view_item_list',
    ecommerce: {
      item_list_name: list,
      items: products.map((product, index) => productModel(
        product.details,
        { list, index },
      )),
    },
  };
};

export default impressionModel;
